import { startCase } from 'es-toolkit';

import { LumberGrade, LumberTreatmentType } from '@paragon/contract-library';

/**
 * Generally prefer `formatLumberGrade` from contract-library, but for certain cases we want the spelled out grade.
 */
export function makeGradeHumanReadable(grade: LumberGrade): string {
  return grade.split('_').join(' ');
}

export function makeLumberTreatmentTypeHumanReadable(type: LumberTreatmentType): string {
  return startCase(type);
}
